import {getAccessToken} from '../auth/token';
import {notification} from "antd";

const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';
const apiBasePath = localMode ? '' : process.env.REACT_APP_API_URL;

export const getAuthOptions = () => {
  return {
    withCredentials: true,
    credentials: 'include',
    headers: {
      Authorization: getAuthHeader()
    }
  }
};

export const api_path = (path) => {
  return `${apiBasePath}/api${path}`;
}

export const getAuthHeader = () => {
  return `Bearer ${getAccessToken()}`
}

export const get = async (path) => {
  try {
    const res = await fetch(api_path(path), {
      ...getAuthOptions(),
      method: 'GET'
    });
    if (res.ok) {
      return await res.json();
    }
    displayErrorNotification(res);
  } catch (e) {
    displayErrorNotification(e);
  }
  return null;
};

export const post = async (path, body, shouldDisplayError = true) => {
  try {
    return new Promise((resolve, reject) => {
      fetch(api_path(path), {
        ...getAuthOptions(),
        method: 'POST',
        body: JSON.stringify(body)
      }).then(response => {
        if (response.ok) {
          return resolve(response);
        }
        if (!response.ok){
          if(shouldDisplayError){
            displayErrorNotification(response);
          }
        return reject(response);
      }}).catch(error => {
        displayErrorNotification(error);
        return reject(error);
      })
    });
  } catch (e) {
    displayErrorNotification(e)
  }
};

export const download = async (path, body) => {
  const res = await fetch(api_path(path), {
    ...getAuthOptions(),
    method: 'POST',
    body: JSON.stringify(body)
  });
  return await res.blob();
};

export const put = async (path, body) => {
  try {
    return new Promise((resolve, reject) => {
      fetch(api_path(path), {
        ...getAuthOptions(),
        method: 'PUT',
        body: JSON.stringify(body)
      }).then(response => {
        if (response.ok) {
          return resolve(response);
        }
        displayErrorNotification(response);
        return reject(response);
      }).catch(error => {
        displayErrorNotification(error);
        return reject(error);
      })
    });
  } catch (e) {
    displayErrorNotification(e)
  }
};

export const del = async (path, body) => {
  try {
    return new Promise((resolve, reject) => {
      fetch(api_path(path), {
        ...getAuthOptions(),
        method: 'DELETE',
        body: JSON.stringify(body)
      }).then(response => {
        if (response.ok) {
          return resolve(response);
        }
        displayErrorNotification(response);
        return reject(response);
      }).catch(error => {
        displayErrorNotification(error);
        return reject(error);
      })
    });
  } catch (e) {
    displayErrorNotification(e)
  }
};

const displayErrorNotification = response => {
  if (response instanceof Response) {
    const cloned = response.clone();
    response.json().then(data => {
      if (data && data.error) {
        notification.error({
          message: `Error ${response.status}`,
          description: (<>
            {response.statusText}<br/>{data.error}
          </>)
        });
      } else {
        notification.error({
          message: `Error ${response.status}`,
          description: response.statusText
        });
      }
    }).catch(() => {
      cloned.text().then(text => {
        if (text && typeof text === 'string') {
          notification.error({
            message: `Error ${response.status}`,
            description: (<>{response.statusText}<br/>{text}</>)
          });
        } else {
          notification.error({
            message: `Error ${response.status}`,
            description: response.statusText
          });
        }
      });
    });
  } else if (response instanceof TypeError) {
    notification.error({
      message: (<>An error occurred, see console for more information<br/>{response.message}</>)
    });
  } else {
    throw Error('Response type not supported');
  }
};
